import { addClass, removeClass } from "./utils"

export function makeExpandable(opts) {
  function hide(el) {
    el.style.display = "none";
  }

  function show(el) {
    el.style.display = "";
  }

  var show_limit = opts.show_limit;
  var show_count = opts.show_count;
  var prefix = opts.prefix;
  var namespace = opts.namespace + prefix;

  var list = document.getElementById(prefix + "_list");
  var cnt = document.getElementById(prefix + "_expand_cnt");
  var btn = document.getElementById(prefix + "_expand_btn");

  if (!list) {
    console.log("Expandor: didn't find #" + prefix + "_list. Skipping.");
    if (btn) hide(btn);
    return;
  }

  var items = list.children;

  btn.addEventListener("click", function (evt) {
    (expanded ? contract : expand)();
    evt.preventDefault();
  });

  var expanded = true;

  function expand() {
    for (var i = show_count; i < items.length; i++) show(items[i]);
    addClass(btn, "contract");
    removeClass(btn, "expand");
    localStorage.setItem(namespace + "_expanded", "Y");
    if (expanded) return false;
    expanded = true;
    return true;
  }

  function contract() {
    for (var i = show_count; i < items.length; i++) hide(items[i]);
    removeClass(btn, "contract");
    addClass(btn, "expand");
    localStorage.setItem(namespace + "_expanded", "N");
    if (!expanded) return false;
    expanded = false;
    return true;
  }

  $(list).data("expandor", {expand: expand, contract: contract});

  if (items.length > show_limit) {
    cnt.innerText = items.length - show_count;
    addClass(list.parentNode, "contractable");
    if (localStorage.getItem(namespace + "_expanded") === "Y") expand();
    else contract();
  } else {
    console.log("Expandor: " + prefix + " has less items than " + show_limit + ". Skipping.");
    if(btn.parentNode.childElementCount === 1) hide(btn.parentNode);
    hide(btn);
  }
}
